<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/pedidos_anim.json'
import exportFromJSON from "export-from-json"
import moment from "moment/moment";
import DxButton from 'devextreme-vue/button';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Pedidos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader, Vue3Lottie,
    DxButton, DxDropDownButton,DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
  },
  mounted() {
    console.log('mounted pedidos-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      animationJson,
      title: 'Pedidos',
      items: [
        {
          text: 'Comercial',
          href: '/',
        },
        {
          text: 'Pedidos',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      pedidoList: null,
      pesqTextFilter: '',
      // statusFilter: 'T',
      valorTotalConf: 0,
      valorTotalCanc: 0,
      valorTotalFat: 0,

      pedChart1: null,
      pedChart2: null,


      showModalPeriodo: false,
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,

      showModalAux: false,
      statusFilterValue: 'T',
      statusFilter: [
        {value: 'T', text: 'Todos os Status'},
        {value: 'CA', text: 'Cancelados'},
        {value: 'CO', text: 'Confirmados'},
        {value: 'CP', text: 'Conf. Parcial'},
        {value: 'EL', text: 'Em Elaboração'},
        {value: 'FA', text: 'Faturados'},
        {value: 'SC', text: 'Solicitação Cancelamento'},
      ],
    }
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance
    }
  },

  methods: {

    importarXML() {
      console.log('importarXML')
      this.$router.push('/pedido/importar/0')
    },


    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    abrirAuxiliar() {
      console.log('abrir auxiliar')
      this.showModalAux = true
    },

    emitRelat001() {
      console.log('emitRelat001')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped01`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_pedidos_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat002() {
      console.log('emitRelat002')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped02`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_pedidos_002.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat003() {
      console.log('emitRelat003')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped03`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_pedidos_003.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    exportExcel() {
      console.log('exportExcel')
      const data = this.pedidoList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({data, fileName, exportType});
    },

    atualizaDataList() {

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment().add(-30, 'days').startOf('month').format('YYYY-MM-DD')
        // let perIniPadrao = moment().add(-1, 'days').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      this.loadingList = true
      api.get(`${getBaseUrl()}api/pedidos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data[0])
        this.pedidoList = res.data[0]

        const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')

        this.title = `(${this.pedidoList.length}) Pedidos: ${dtIniFormated} - ${dtFimFormated}`
        this.loadingList = false

        // console.log('res.data[1]')
        // console.log(res.data[1])


        let valorTotalLoc = 0
        let valorTotalConf = 0
        let valorTotalCanc = 0
        let valorTotalFat = 0
        this.pedidoList.forEach((value) => {

          valorTotalLoc += value.valorliq

          if (value.status === 'CA') {
            valorTotalCanc += value.valorliq
          } else if (value.status === 'CO') {
            valorTotalConf += value.valorliq
          } else if (value.status === 'FA' && value.stsefaz === 'AT') {
            valorTotalFat += value.valorliq
          }

        })

        this.valorTotal = valorTotalLoc
        this.valorTotalCanc = valorTotalCanc
        this.valorTotalConf = valorTotalConf
        this.valorTotalFat = valorTotalFat


        let labelsLocG1 = []
        let series01G1 = []
        let series02G1 = []
        let series03G1 = []
        res.data[1].forEach((value) => {
          labelsLocG1.push(value.month)
        })
        const uniquelabelsLocG1 = [...new Set(labelsLocG1)]
        // console.log('uniquelabelsLocG1')
        // console.log(uniquelabelsLocG1)
        uniquelabelsLocG1.forEach((value0) => {
          // console.log('value0')
          // console.log(value0)
          let acuFat = 0
          let acuCanc = 0
          let acuOutr = 0
          res.data[1].forEach((value1) => {
            if (value1.month === value0) {
              if (value1.status === 'FA') {
                acuFat += parseInt(value1.valor)
              } else if (value1.status === 'CA') {
                acuCanc += parseInt(value1.valor)
              } else {
                acuOutr += parseInt(value1.valor)
              }
            }
            //labelsLocG1.push(value.month)
          })
          series01G1.push(acuFat)
          series02G1.push(acuOutr)
          series03G1.push(acuCanc)
        })
        // console.log('series01G1')
        // console.log(series01G1)

        this.pedChart1 = {
          series: [{
            name: 'Faturado',
            type: 'area',
            data: series01G1
          }, {
            name: 'Outros',
            type: 'line',
            data: series02G1
          }, {
            name: 'Cancelado',
            type: 'column',
            data: series03G1
          }],
          chartOptions: {
            chart: {
              stacked: false,
              toolbar: {
                show: false
              }
            },
            stroke: {
              width: [0, 2, 4],
              curve: 'smooth'
            },
            plotOptions: {
              bar: {
                columnWidth: '50%'
              }
            },
            colors: ['#34c38f', '#556ee6', '#f46a6a'],
            fill: {
              opacity: [0.45, 0.85, 1],
              gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
              }
            },
            labels: uniquelabelsLocG1,
            markers: {
              size: 0
            },
            xaxis: {
              //type: 'datetime'
            },
            yaxis: {
              title: {
                text: 'Pedidos',
              },
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (y) {
                  if (typeof y !== "undefined") {
                    return "R$ " + y.toFixed(0)
                  }
                  return y
                }
              }
            },
            grid: {
              borderColor: '#f1f1f1'
            }
          }
        }

        let labelsLocG2 = []
        let series01G2 = []
        let valorTotal = 0.00
        res.data[2].forEach((value) => {
          valorTotal += parseInt(value.valor)
        })
        console.log('valorTotal_G2')
        console.log(valorTotal)
        res.data[2].forEach((value) => {
          console.log(value)
          labelsLocG2.push(value.repres)

          const valorPerc = parseInt(value.valor / valorTotal * 100)
          console.log(valorPerc)

          series01G2.push(valorPerc)
        })


        this.pedChart2 = {

          series: series01G2,
          chartOptions: {
            labels: labelsLocG2,
            colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
            legend: {
              show: true,
              position: 'bottom',
              horizontalAlign: 'center',
              verticalAlign: 'middle',
              floating: false,
              fontSize: '14px',
              offsetX: 0
            },
            responsive: [{
              breakpoint: 600,
              options: {
                chart: {
                  height: 240
                },
                legend: {
                  show: false
                },
              }
            }]
          }

        }


        this.loadingGraph = false
      })
    },

    criarNovo() {
      console.log('criarNovo')

      window.open(this.$router.resolve({ path: '/orcamento/editar/0' }).href,'_blank');
      // this.updating = !this.updating
    },

    carregouGrid(e) {
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Pedidos: ${dtIniFormated} - ${dtFimFormated}`
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')

      let idData = row.key
      console.log(idData)

      window.open(this.$router.resolve({ path: `/pedido/detalhe/${idData}` }).href,'_blank');
      // this.$router.push(`/pedido/detalhe/${idData}`)

    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SC':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CO':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'FA':
              corStatus = 'rgb(253,179,52)'
              break
            case 'EL':
              corStatus = 'rgb(5,126,236)'
              break
            case 'CP':
              corStatus = 'rgb(144,214,127)'
              break

          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
        if (e.column.dataField === "stsefaz") {
          const valSttSefaz = e.data.stsefaz
          let corSttSefaz = 'rgba(146,20,0,0.5)'
          switch (valSttSefaz) {
            case 'CA':
              corSttSefaz = 'rgba(146,20,0,0.5)'
              break
            case 'NG':
              corSttSefaz = 'rgba(146,20,0,0.5)'
              break
            case 'AT':
              corSttSefaz = 'rgba(33,78,0,0.5)'
              break
            case 'XM':
              corSttSefaz = 'rgb(253,179,52)'
              break
            case 'Ev':
              corSttSefaz = 'rgb(253,179,52)'
              break

          }
          e.cellElement.style.cssText = `color: white; background-color: ${corSttSefaz}`;

        }
      }
    },

    /*onDropClick(e) {
      const clickedValue = e.itemData.value;

      switch (clickedValue) {
        case 'imp':
          this.importExcel();
          break;
        case 'exp':
          this.exportExcel();
          break;
        case 'relPer':
          this.emitRelatPer();
          break;
        case 'relRep':
          this.emitRelatRep();
          break;
        default:
          console.log('Ação não definida');
      }
    },*/

    onFilterClick(e) {
      const filteredValue = e.itemData.value;
      this.statusFilterValue = filteredValue;

      this.atualizaDataList();
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatCodOrcto(e){
      console.log('formatCodOrcto')
      console.log(e)
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'FA':
          return 'Faturado (FA)'
        case 'EL':
          return 'Em Elaboração (EL)'
        case 'CP':
          return 'Conf. Parcial (CP)'
        case 'CO':
          return 'Confirmado (CO)'
        case 'CA':
          return 'Cancelado (CA)'
        case 'SC':
          return 'Solicitação cancelamento (SC)'
      }

      return 'Não Definido'
    },

    nomeSttSefaz(e){
      switch (e.value) {
        case 'AT':
          return 'NFe Autorizada'
        case 'XM':
          return 'XML Disponível'
        case 'CA':
          return 'NFe Cancelada'
        case 'EV':
          return 'Envio para Sefaz pendente'
        case 'NG':
          return 'Negado pelo Sefaz'

      }

      return 'Não Definido'
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }


  },


}
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1000; position: absolute; top: 10px; right: 170px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250"/>
    </span>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>
      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxDropDownButton
              v-model="statusFilterValue"
              :items="statusFilter"
              :drop-down-options="{ width: 150 }"
              icon="filter"
              show-arrow="false"
              hint="Filtrar Status"
              display-expr="text"
              value-expr="value"
              @item-click="onFilterClick"
          />
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Cadastrar novo orçamento"
              text="Novo Orçamento"
              :on-click="criarNovo"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="file"
              hint="Auxiliar"
              text="Auxiliar"
              :on-click="abrirAuxiliar"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="loadingList" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!loadingList">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="pedidoList"
          :show-borders="true"
          :focused-row-enabled="true"
          :keyExpr="'id'"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strOrçamentoList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping/>

        <DxColumn
            data-field="id"
            caption="ID"
            sort-order="desc"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pedido_orcamento_id"
            caption="origem ID"
            sort-order="desc"
            data-type="number"
            alignment="center"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pedido_origem"
            caption="Origem"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            data-type="text"
            alignment="center"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="stsefaz"
            caption="Stt. Sefaz"
            data-type="text"
            alignment="center"
            :customize-text="nomeSttSefaz"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="nomecli"
            caption="Cliente"
            sort-order="desc"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

          <DxColumn
            data-field="orcto_codigo"
            caption="Cód. Orçamento"
            sort-order="desc"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="nota_nnf"
            caption="Número NF-e"
            sort-order="desc"
            data-type="text"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

          <DxColumn
            data-field="nota_codigo"
            caption="NF-e"
            sort-order="desc"
            data-type="text"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

          <DxColumn
            data-field="nota_dtemit"
            caption="Emissão NF-e"
            sort-order="desc"
            data-type="datetime"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_id"
            caption="Financ. ID"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="empresa_cnpj"
            caption="CNPJ Emissor"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cnpj"
            caption="CNPJ Destino"
            data-type="text"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cidade"
            caption="Cidade"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="estado"
            caption="UF"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="dtemissao"
            caption="Data"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['contains','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="desccond"
            caption="Condição Pgto"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="formapgtodesc"
            caption="forma Pgto"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="110"
            data-field="peso"
            caption="Peso"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="110"
            data-field="valorliq"
            caption="Valor"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Resumo Pedidos" v-model="showModalAux" centered hide-footer >

      <div v-if="!loadingList">
        <div>
          <div>
            <p class="text-muted mb-2">Total</p>
            <h5 class="mb-0">{{ formatDecimal(valorTotal) }} (Valor Total) </h5>
          </div>
        </div>
        <hr>
        <div>
          Faturado:
          <span class="float-end"> {{ formatDecimal(valorTotalFat) }} (0%)</span>
        </div>
        <div>
          Confirmado:
          <span class="float-end"> {{ formatDecimal(valorTotalConf) }} (0%)</span>
        </div>
        <div>
          Cancelado:
          <span class="float-end"> {{ formatDecimal(valorTotalCanc) }} (0%)</span>
        </div>

        <hr>

        <a class="dropdown-item text-primary text-center"
           @click="exportExcel"
           href="javascript: void(0);">
          Exportar Excel
        </a>

        <hr>

        <a class="dropdown-item text-primary text-center"
           @click="importarXML"
           href="javascript: void(0);">
          Importar XML
        </a>

        <hr>
        <a class="dropdown-item text-primary text-center"
           @click="emitRelat001"
           href="javascript: void(0);">
          Relatório de Pedidos Diário
        </a>

        <a class="dropdown-item text-primary text-center"
           @click="emitRelat002"
           href="javascript: void(0);">
          Relatório de Pedidos Mês
        </a>

        <a class="dropdown-item text-primary text-center"
           @click="emitRelat003"
           href="javascript: void(0);">
          Pedidos por Representante
        </a>
      </div>
    </b-modal>

  </Layout>
</template>
